import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    insurance: [
        // {
        //     company: '保険会社1',
        //     type: '保険の種類1',
        //     policyNumber: '保険証券番号1',
        //     insured: '被保険者1',
        //     contractor: '契約者1',
        //     recipient: '保険金受取人1',
        //     amountMoney: '金額1',
        //     targetPerson: 'テスト相続人1',
        //     inheritanceBequest: '相続',
        // },
        // {
        //     company: '保険会社2',
        //     type: '保険の種類2',
        //     policyNumber: '保険証券番号2',
        //     insured: '被保険者2',
        //     contractor: '契約者2',
        //     recipient: '保険金受取人2',
        //     amountMoney: '金額2',
        //     targetPerson: 'テスト相続人2',
        //     inheritanceBequest: '相続',
        // },
        // {
        //     company: '保険会社3',
        //     type: '保険の種類3',
        //     policyNumber: '保険証券番号3',
        //     insured: '被保険者3',
        //     contractor: '契約者3',
        //     recipient: '保険金受取人3',
        //     amountMoney: '金額3',
        //     targetPerson: 'テスト相続人3',
        //     inheritanceBequest: '相続',
        // }
    ]
};

const slice = createSlice({
    name: 'insurance',
    initialState,
    reducers: {
        setInsurance: (state, action) => {
            return Object.assign({}, state, { insurance: state.insurance.concat(action.payload) })
        },
        clearInsurance: (state, action) => {
            const newArray = Array.from(new Set([...state.insurance]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { insurance: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setInsurance,
    clearInsurance,
} = slice.actions;
